import clsx from "clsx";
import { Grid, Tooltip, Typography } from "@material-ui/core";
import ErrorIcon from "@material-ui/icons/Error";
import { lang } from "i18nLang";

export const DetailTitle = ({
  classes,
  label,
  show = true,
}: {
  classes: any;
  label: string;
  show?: boolean;
}) => {
  if (!show) return <></>;
  return (
    <Grid
      container
      item
      alignItems="center"
      className={clsx("title", classes.cellHead, classes.cell)}
    >
      <Typography variant="caption" className={classes.detailTitle}>
        {label}
      </Typography>
    </Grid>
  );
};

export const DetailValue = ({
  classes,
  label,
  value,
  show = true,
}: {
  classes: any;
  label: string;
  value: any;
  show?: boolean;
}) => {
  if (!show) return <></>;

  return (
    <Grid
      container
      item
      direction="column"
      justifyContent="center"
      className={clsx(classes.detailContainer, classes.cell)}
    >
      <Typography variant="caption" className={classes.detailLabel}>
        {label}
      </Typography>
      <Typography variant="body1" className={classes.detailValue}>
        {value}
      </Typography>
    </Grid>
  );
};

export const BillingDetailValues = ({
  classes,
  label,
  value,
  caption,
  error = false,
}: {
  classes: any;
  label: string;
  value: any;
  caption?: string;
  error?: boolean;
}) => {
  return (
    <Grid
      container
      item
      direction="column"
      justifyContent="center"
      className={clsx(classes.detailContainer, classes.cell)}
    >
      <Typography variant="caption" className={classes.detailLabel}>
        {label}
      </Typography>
      {!error ? (
        <Typography variant="body1" className={classes.detailValue}>
          {value}
        </Typography>
      ) : (
        <Grid container alignItems="center">
          <Tooltip
            title={
              <>
                <Typography variant="body1" className={classes.detailValue}>
                  {value}
                </Typography>
                {caption && (
                  <Typography
                    variant="caption"
                    style={{ whiteSpace: "break-spaces", fontSize: "0.625rem" }}
                  >
                    {caption}
                  </Typography>
                )}
              </>
            }
          >
            <ErrorIcon
              color="error"
              fontSize="small"
              style={{ marginRight: 5 }}
            />
          </Tooltip>
          <Typography
            variant="body1"
            className={classes.detailValue}
            color="error"
          >
            {lang("error")}
          </Typography>
        </Grid>
      )}
    </Grid>
  );
};

export const BillingDetailsRow = ({
  classes,
  invoiceNumber,
  invoiceSerial,
  invoiceDate,
}) => {
  const label = "measurements.table";
  if (!invoiceNumber) return <></>;

  return (
    <Grid
      container
      item
      spacing={5}
      className={clsx("billing-details", classes.cell)}
      style={{ marginTop: 0 }}
    >
      <DetailValue
        classes={classes}
        label={lang(`${label}.invoices`)}
        value={invoiceNumber}
      />
      {Boolean(invoiceSerial) && (
        <>
          <DetailValue
            classes={classes}
            label={lang(`${label}.serial`)}
            value={invoiceSerial}
          />
          <DetailValue
            classes={classes}
            label={lang(`${label}.issuanceDate`)}
            value={invoiceDate}
          />
        </>
      )}
    </Grid>
  );
};
